/* eslint-disable sonarjs/cognitive-complexity */
import React, { useMemo } from 'react';
import { Formik } from 'formik';
import { PropTypes } from 'prop-types';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Col, Row } from 'antd';
import { Form, Radio } from 'formik-antd';
import { useDispatch } from 'react-redux';
import { Box, FormInput, CustomInput, Button } from 'atoms';
import { Debug } from '../Debug';
import { updateClient } from 'store/clientSlice';
import { ACL, EditModeBtn } from 'components/common';
import { useQuery } from 'hooks';
import { CancelButton } from 'utils/commonStyled';

const FormSchema = Yup.object({
	credit_amt: Yup.number().required().min(1).max(999999).label('Credit Amount'),
	tax_exempt: Yup.boolean().required().label('Tax exempt'),
	document_currency: Yup.string()
		.label('Document Currency')
		.matches(/^[a-zA-Z]*$/, 'Please enter valid Document Currency'),
	credit_period: Yup.number().min(1).max(999).label('credit period'),
	payment_tnc: Yup.string()
		.label('payment tnc')
		.matches(/^[a-zA-Z]*$/, 'Please enter valid payment tnc'),
});
export default function OtherInfoForm({ isEditMode = false, formData = {}, otherFormsData }) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [query] = useQuery();

	const initialValues = useMemo(
		() => ({
			credit_amt: formData?.credit_amt || undefined,
			tax_exempt: formData?.tax_exempt || false,
			related_party: formData?.related_party || false,
			black_listed: formData?.black_listed || false,
			same_as_billing_loc: formData?.same_as_billing_loc || false,
			document_currency: formData?.document_currency || undefined,
			credit_period: formData?.credit_period || undefined,
			payment_tnc: formData?.payment_tnc || undefined,
		}),
		[formData]
	);

	const handleSubmit = (values, { setErrors, setSubmitting }) => {
		console.log(otherFormsData);

		const payload = {
			...otherFormsData,
			other_info: {
				...values,
				credit_amt: Number(values.credit_amt),
			},
		};

		if (isEditMode) {
			payload.update_type = 'client';
		} else {
			payload.create_type = 'client';
		}
		dispatch(updateClient({ req_data: payload, info: 'other_info', setErrors }))
			.then((res) => {
				console.log('client infor res', res);
				setSubmitting(false);
				navigate(`/clients`);
			})
			.catch(() => {
				setSubmitting(false);
			});
	};

	return (
		<Formik
			initialValues={initialValues}
			validationSchema={FormSchema}
			onSubmit={handleSubmit}
			enableReinitialize
		>
			{(values) => (
				<Box>
					<ACL action="update" module="client">
						{isEditMode && <EditModeBtn />}
					</ACL>
					<Form className={query.get('isEdit') === 'false' ? 'disabled-div' : ''}>
						<Box padding="1.5rem 2rem" background="#fff">
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="related_party" label="Related Party">
										<Radio.Group
											name="related_party"
											defaultValue={values?.tax_exempt}
										>
											<Radio value>Yes</Radio>
											<Radio value={false}>No</Radio>
										</Radio.Group>
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput
										name="same_as_billing_loc"
										label="Same as Billing Loc"
									>
										<Radio.Group
											name="same_as_billing_loc"
											defaultValue={values?.same_as_billing_loc}
										>
											<Radio value>Yes</Radio>
											<Radio value={false}>No</Radio>
										</Radio.Group>
									</FormInput>
								</Col>
							</Row>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="tax_exempt" label="Tax Exempt *">
										<Radio.Group
											name="tax_exempt"
											defaultValue={values?.tax_exempt}
										>
											<Radio value>Yes</Radio>
											<Radio value={false}>No</Radio>
										</Radio.Group>
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="black_listed" label="Black listed">
										<Radio.Group
											name="black_listed"
											defaultValue={values?.black_listed}
										>
											<Radio value>Yes</Radio>
											<Radio value={false}>No</Radio>
										</Radio.Group>
									</FormInput>
								</Col>
							</Row>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="credit_amt" label="Credit amount *">
										<CustomInput name="credit_amt" />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="document_currency" label="Document Currency">
										<CustomInput name="document_currency" />
									</FormInput>
								</Col>
							</Row>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="credit_period" label="Credit Period">
										<CustomInput name="credit_period" />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="payment_tnc" label="Payment tnc">
										<CustomInput name="payment_tnc" />
									</FormInput>
								</Col>
							</Row>
						</Box>
						<Box backgroundColor="#f5f5f5" textAlign="right" padding="1.5rem">
							<CancelButton onClick={() => navigate('/client-list')} type="button">
								Cancel
							</CancelButton>
							<Button borderRadius="4px" backgroundColor="#18405d" type="submit">
								{isEditMode ? 'Update' : 'Submit'}
							</Button>
						</Box>
						<Debug />
					</Form>
				</Box>
			)}
		</Formik>
	);
}

OtherInfoForm.propTypes = {
	isEditMode: PropTypes.bool,
	formData: PropTypes.object,
	otherFormsData: PropTypes.object,
};
